export enum UserCategory {
  STUDENT = 'student',
  TEACHER = 'teacher',
  PARENT = 'parent',
  OTHER = 'other',
}

export enum QUESTION_TAG {
  GENERAL = 'General',
  MOTIVATION_AND_DRIVE = 'Motivation & Drive',
  WHO_YOU_ARE_AND_YOUR_GOALS = 'Who You Are & Your Goals',
  CONFIDENCE_AND_MATH_MINDSET = 'Confidence & Math Mindset',
  STUDY_STRATEGY_AND_TACTICS = 'Study Strategy & Tactics',
  CHILD_LEARNING_PREFERENCES_AND_PARENT_SUPPORT_STYLE = 'Child learning preferences & parent support style',
  HOME_ROUTINES_AND_FRICTION_SIGNALS = 'Home routines & friction signals',
  PARENT_CAPABILITY_AND_NEED_FOR_CLARITY = 'Parent capability & need for clarity',
  MOTIVATION_MINDSET_AND_REINFORCEMENT_CULTURE_AT_HOME = 'Motivation, mindset & reinforcement culture at home',
  TEACHING_ROLE_AND_CLASSROOM_SETTING = 'Your Teaching Role & Classroom Setting',
  TEACH_AND_MOTIVATE_STUDENTS = 'How you teach and motivate your students',
  REACH_EVERY_STUDENT = 'How you reach every student',
  STUDENT_INSIGHT = 'Your student insight',
  USE_OF_ASSESSMENT_AND_ANALYSIS = 'Your use of assessment & analysis',
  PARENT_PROFILE_AND_SCOPE = 'Parent profile & scope',
  EMPTY = '',
  INVALID = 'invalid',
}

export enum UsOnboardingOnboardingStep {
  BECOME_A_MATH_MASTER = 'become-a-math-master',
  GRADE_SELECTION = 'grade-selection',
  LEARNERS = 'learners',
  GENDER_SELECT = 'gender-select',
  GREAT_TO_SEE_YOU = 'great-to-see-you',
  CHOOSE_WAYS = 'choose-ways',
  ADVERTISEMENT_PAGES = 'advertisement-pages',
  SELECT_CAREERS = 'select-careers',
  BIG_PICTURE_OR_DETAIL = 'big-picture-or-detail',
  BIG_PICTURE_OR_DETAIL_DRAGON = 'big-picture-or-detail-dragon',
  PRIORITIZE_HOMEWORK = 'prioritize-homework',
  DOUBT_MYSELF = 'doubt-myself',
  DOUBT_MYSELF_DRAGON = 'doubt-myself-dragon',
  DESCRIBE_BEST = 'describe-best',
  FIND_CHALLENGING = 'find-challenging',
  FIND_CHALLENGING_DRAGON = 'find-challenging-dragon',
  LACK_INNER_POWER = 'lack-inner-power',
  PERSONAL_MATH_RECIPE = 'personal-math-recipe',
  LIKE_TO_BE_ENCOURAGED = 'like-to-be-encouraged',
  FRIENDLY_PUSH = 'friendly-push',
  FRIENDLY_PUSH_DRAGON = 'friendly-push-dragon',
  COMMUNICATION_TONE = 'communication-tone',
  MATH_CONFIDENT = 'math-confident',
  BETTER_UNDERSTAND_MATH = 'better-understand-math',
  PERSONAL_MATH_RECIPE_2 = 'personal-math-recipe-2',
  SUCCEED_IN_SOMETHING = 'succeed-in-something',
  SUCCEED_IN_SOMETHING_DRAGON = 'succeed-in-something-dragon',
  LIKE_MATH = 'like-math',
  LIKE_MATH_DRAGON = 'like-math-dragon',
  MATH_ROUTINE = 'math-routine',
  MATH_ROUTINE_DRAGON = 'math-routine-dragon',
  FEEL_MATH_SKILLS = 'feel-math-skills',
  FEEL_MATH_SKILLS_DRAGON = 'feel-math-skills-dragon',
  JUST_NOT_A_MATH_PERSON = 'just-not-a-math-person',
  JUST_NOT_A_MATH_PERSON_DRAGON = 'just-not-a-math-person-dragon',
  EMAIL_US = 'email-us',
  STUCK_TO_GOT = 'stuck-to-got',
  CRAFTING_YOUR_EXPERIENCE = 'crafting-your-experience',
  MATH_PLAN_METHOD = 'math-plan-method',
  BEST_LEARN = 'best-learn',
  TIME_YOU_COMMIT = 'time-you-commit',
  IMPROVING_MATH_REASON = 'improving-math-reason',
  MATH_PRACTICE_CHALLENGES = 'math-practice-challenges',
  HEAR_ABOUT_HOM_TEACHER = 'hear-about-hom-teacher',
  MATH_PLAN_READY = 'math-plan-ready',
  WORLD_WIDE_LEARNERS = 'world-wide-learners',
  ALMOST_THERE = 'almost-there',
  SIGN_UP = 'sign-up',
  CHOOSE_YOUR_PLAN_STEP_ONE = 'choose-your-plan-step-one',
}

export enum UsOnboardingUrls {
  ROLE = '/get-started/us/role',
  INTRO = '/get-started/us/intro',
  QUIZ = '/get-started/us/quiz',
  PAYMENT = '/get-started/us/payment',
}

export type ImageSrcKey =
  | 'student'
  | 'student.1'
  | 'student.2'
  | 'student.3'
  | 'student.4'
  | 'parent'
  | 'parent.1'
  | 'parent.2'
  | 'parent.3'
  | 'parent.4'
  | 'teacher'
  | 'teacher.1'
  | 'teacher.2'
  | 'teacher.3'
  | 'teacher.4'
  | 'other'
  | 'other.1'
  | 'other.2'
  | 'other.3'
  | 'other.4'

export type ImageSrcConfig = Partial<{
  [key in ImageSrcKey]: string
}>

export interface StepConfig {
  id: string
  baseKey: string
  component: React.ComponentType<any>
  title: string
  subtitle?: string
  imageSrc?: ImageSrcConfig
  path: string
  tag: Record<UserCategory, QUESTION_TAG>
}
